import { fetchBluetoothPairingGuides, } from '@gn-audio/core/api/knowledge-base';
import { smoothScroll } from '@gn-audio/ui/tools/smooth-srcoll';
import { spotName } from '../constants/spot-name';
import { getBackgroundImageStyle } from '../utils/get-background-image-style';
var sectionId = 'btpg-section';
var BtpgSpotV2Controller = (function () {
    function BtpgSpotV2Controller($scope, $q, $location, productContextService) {
        this.$scope = $scope;
        this.$q = $q;
        this.$location = $location;
        this.productContextService = productContextService;
        this.$scope.guides = [];
        this.$scope.activeStepIndex = 0;
    }
    BtpgSpotV2Controller.prototype.$onInit = function () {
        this.productContextService
            .subscribe()
            .then(null, null, this.onGroupSelected.bind(this));
        this.$scope.setActiveStepIndex = this.setActiveStepIndex.bind(this);
        this.$scope.onGuideSelect = this.onGuideSelect.bind(this);
        this.$scope.isStepActive = this.isStepActive.bind(this);
        this.$scope.isGuideActive = this.isGuideActive.bind(this);
        this.$scope.isNextVisible = this.isNextVisible.bind(this);
        this.$scope.isPrevVisible = this.isPrevVisible.bind(this);
        this.$scope.getBackgroundImageStyle = getBackgroundImageStyle;
        this.$scope.getMobileNote = this.getMobileNote.bind(this);
    };
    BtpgSpotV2Controller.prototype.getGuides = function (id) {
        var _this = this;
        this.$q.when(fetchBluetoothPairingGuides(id))
            .then(function (guides) {
            _this.$scope.guides = guides || [];
            _this.handlePreConfig();
        });
    };
    BtpgSpotV2Controller.prototype.setActiveStepIndex = function (newIndex) {
        var _a;
        if (newIndex >= 0 && ((_a = this.$scope.selectedGuide) === null || _a === void 0 ? void 0 : _a.steps.length) > newIndex) {
            this.$scope.activeStepIndex = newIndex;
        }
    };
    BtpgSpotV2Controller.prototype.onGuideSelect = function (guide) {
        this.$scope.selectedGuide = guide;
        this.setActiveStepIndex(0);
    };
    BtpgSpotV2Controller.prototype.getMobileNote = function () {
        var _a;
        if ((_a = this.$scope.selectedGuide) === null || _a === void 0 ? void 0 : _a.platform) {
            var _b = this.$scope.selectedGuide.platform, note = _b.note, mobileNote = _b.mobileNote;
            return mobileNote || note;
        }
        return undefined;
    };
    BtpgSpotV2Controller.prototype.onGroupSelected = function (group) {
        this.$scope.group = group;
        this.getGuides(group.groupId);
    };
    BtpgSpotV2Controller.prototype.isStepActive = function (index) {
        return index === this.$scope.activeStepIndex;
    };
    BtpgSpotV2Controller.prototype.isGuideActive = function (guide) {
        return guide === this.$scope.selectedGuide;
    };
    BtpgSpotV2Controller.prototype.isNextVisible = function () {
        var _a;
        return this.$scope.activeStepIndex < (((_a = this.$scope.selectedGuide) === null || _a === void 0 ? void 0 : _a.steps.length) - 1);
    };
    BtpgSpotV2Controller.prototype.isPrevVisible = function () {
        return this.$scope.activeStepIndex !== 0;
    };
    BtpgSpotV2Controller.prototype.scrollTo = function (element) {
        if (element) {
            smoothScroll(element);
        }
    };
    BtpgSpotV2Controller.prototype.handlePreConfig = function () {
        var _a;
        var _b = this.$location.search(), platformLabel = _b.platformLabel, stepId = _b.stepId;
        if (this.$location.path().toUpperCase() === "/" + spotName) {
            this.scrollTo(document.querySelector("#" + sectionId));
            this.$location.url('').search('');
        }
        if (platformLabel) {
            this.$scope.selectedGuide = this.$scope.guides
                .filter(function (guide) { var _a; return ((_a = guide.platform) === null || _a === void 0 ? void 0 : _a.label) === platformLabel; })[0];
        }
        if (((_a = this.$scope.selectedGuide) === null || _a === void 0 ? void 0 : _a.steps) && stepId) {
            var index = this.$scope.selectedGuide.steps.map(function (step) { return step.id; }).indexOf(stepId);
            this.$scope.activeStepIndex = index >= 0 ? index : 0;
        }
    };
    BtpgSpotV2Controller.$inject = [
        '$scope',
        '$q',
        '$location',
        'productContextService',
    ];
    return BtpgSpotV2Controller;
}());
export { BtpgSpotV2Controller };
